<div *ngIf="data?.button as button" class="generic-text-cta">
    <finder-generic-text [data]="data.genericText"></finder-generic-text>
    <finder-button [theme]="button.theme" [href]="button.link">{{button.label}}</finder-button>
</div>
